export default __webpack_public_path__ + "static/media/snobs.7df8822c.mp4";